import React from "react";
import { Select, InputLabel, OutlinedInput, MenuItem } from "@mui/material";

export const CustomInputSelect = (props) => {
  const {
    id,
    value,
    onChange,
    label,
    placeholder,
    disabled,
    options,
    ...other
  } = props;

  return (
    <>
      <InputLabel htmlFor={id} className="label text-black">
        {label}
      </InputLabel>
      <Select
        input={<OutlinedInput />}
        style={{ borderRadius: "16px", height: "42px" }}
        variant="outlined"
        fullWidth
        displayEmpty
        className="select-input mb-2 label"
        sx={{
          "& .MuiInputBase-input": {
            color: value ? "black" : "gray",
            fontSize: "15px",
            fontWeight: "400",
          },
        }}
        id={id}
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        {...other}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
        {options &&
          options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
    </>
  );
};
